module.exports = __webpack_public_path__ + "img/8.937e37ba.jpg";